/* eslint-disable */
export default {
  cancel: 'Annuleren',
  confirm: 'Bevestigen',
} as const;

// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"confirm"@#@ @source: @#@"Confirm"@#@
